export { array } from './array'
export { object } from './object'
export { regexp } from './regexp'
